// extracted by mini-css-extract-plugin
export var markdown = "_si-0";
export var tableWrapper = "_si-1";